import { Route, Routes } from "react-router-dom";
import LabTestReportFormPage from "./LabTestReportFormPage";
import LabTestReportLoader from "./LabTestReportLoader";
import LabTestReportsPage from "./LabTestReportsPage";

const LabTestReportRoutes = () => {
  return (
    <Routes>
      <Route index element={<LabTestReportsPage />} />
      <Route path="new" element={<LabTestReportFormPage mode="create" />} />
      <Route path=":id" element={<LabTestReportLoader />} />
    </Routes>
  );
};

export default LabTestReportRoutes;
